import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useEffect, useMemo, useCallback } from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';
import authStatusConstants from '../../../constants/authStatusConstants.js';
import paymentCardConstants from '../../../constants/paymentCardConstants.js';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import StripePaymentButton from '../stripe-payment-button/StripePaymentButton.js';
import '../../../mocks/address.js';
import StubbedAuthSelector from '../../stubbed/stubbed-auth-selector/StubbedAuthSelector.js';
import StubbedCardSelector from '../../stubbed/stubbed-card-selector/StubbedCardSelector.js';
import StubbedOrderTotals from '../../stubbed/stubbed-order-totals/StubbedOrderTotals.js';
import StubbedStatusSelector from '../../stubbed/stubbed-status-selector/StubbedStatusSelector.js';
import StubbedWrapper from '../../stubbed/stubbed-wrapper/StubbedWrapper.js';
var StripePaymentElement = function StripePaymentElement(_ref) {
  var amount = _ref.amount,
    beforeButtonContent = _ref.beforeButtonContent,
    billing_details = _ref.billingDetails,
    classNames = _ref.classNames,
    _ref$onReadyToRenderH = _ref.onReadyToRenderHandler,
    onReadyToRenderHandler = _ref$onReadyToRenderH === void 0 ? function () {} : _ref$onReadyToRenderH,
    _ref$onSubmitHandler = _ref.onSubmitHandler,
    onSubmitHandler = _ref$onSubmitHandler === void 0 ? function () {} : _ref$onSubmitHandler,
    isDisabled = _ref.isDisabled,
    isStubbed = _ref.isStubbed,
    paymentHandlers = _ref.paymentHandlers,
    paymentMethodType = _ref.paymentMethodType,
    renderPaymentButton = _ref.renderPaymentButton;
  var _useState = useState(paymentStatus.AUTHORISED),
    _useState2 = _slicedToArray(_useState, 2),
    stubbedStatus = _useState2[0],
    setStubbedStatus = _useState2[1];
  var _useState3 = useState(authStatusConstants.COMPLETE),
    _useState4 = _slicedToArray(_useState3, 2),
    stubbedAuthStatus = _useState4[0],
    setStubbedAuthStatus = _useState4[1];
  var _useState5 = useState(paymentCardConstants.VISA.number),
    _useState6 = _slicedToArray(_useState5, 2),
    stubbedPaymentCard = _useState6[0],
    setStubbedPaymentCard = _useState6[1];
  var onConfirmHandler = function onConfirmHandler(event) {
    event === null || event === void 0 || event.preventDefault();
    onSubmitHandler({
      billingDetails: billing_details,
      stubbedAuthStatus: stubbedAuthStatus,
      stubbedPaymentCard: stubbedPaymentCard,
      stubbedStatus: stubbedStatus
    });
  };
  var onReadyHandler = function onReadyHandler() {
    onReadyToRenderHandler(true);
  };
  useEffect(function () {
    if (isStubbed) {
      var _paymentHandlers$onRe;
      onReadyToRenderHandler(true);
      paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onRe = paymentHandlers.onReady) === null || _paymentHandlers$onRe === void 0 || _paymentHandlers$onRe.call(paymentHandlers, true);
    }
  }, [isStubbed]);
  var paymentElementOptions = useMemo(function () {
    return {
      layout: {
        type: 'tabs',
        defaultCollapsed: false
      },
      fields: {
        billingDetails: {
          name: 'auto',
          address: 'never'
        }
      },
      wallets: {
        applePay: 'never',
        googlePay: 'never'
      }
    };
  }, []);
  var renderStubbedContent = useCallback(function () {
    return jsx("div", {
      className: classNames === null || classNames === void 0 ? void 0 : classNames.form,
      children: jsx("div", {
        className: classNames === null || classNames === void 0 ? void 0 : classNames.paymentElement,
        children: jsxs(StubbedWrapper, {
          children: [jsx(StubbedStatusSelector, {
            stubbedStatus: stubbedStatus,
            onChange: setStubbedStatus
          }), jsx(StubbedAuthSelector, {
            stubbedAuthStatus: stubbedAuthStatus,
            stubbedStatus: stubbedStatus,
            onChange: setStubbedAuthStatus
          }), jsx(StubbedCardSelector, {
            stubbedCard: stubbedPaymentCard,
            onChange: setStubbedPaymentCard
          }), jsx(StubbedOrderTotals, {
            amount: amount,
            onConfirm: onConfirmHandler,
            paymentMethodType: paymentMethodType
          })]
        })
      })
    });
  }, [amount, classNames, onConfirmHandler, paymentMethodType, stubbedAuthStatus, stubbedStatus]);
  var renderLiveContent = useCallback(function () {
    return jsxs("form", {
      className: classNames === null || classNames === void 0 ? void 0 : classNames.form,
      onSubmit: onConfirmHandler,
      children: [jsx("div", {
        className: classNames === null || classNames === void 0 ? void 0 : classNames.paymentElement,
        children: jsx(PaymentElement, {
          options: paymentElementOptions,
          onReady: onReadyHandler
        })
      }), jsx("div", {
        className: classNames === null || classNames === void 0 ? void 0 : classNames.beforeButtonContent,
        children: beforeButtonContent
      }), jsx("div", {
        className: classNames === null || classNames === void 0 ? void 0 : classNames.paymentButton,
        children: jsx(StripePaymentButton, {
          isDisabled: isDisabled,
          renderPaymentButton: renderPaymentButton
        })
      })]
    });
  }, [beforeButtonContent, classNames, isDisabled, onConfirmHandler, onReadyHandler, paymentElementOptions, renderPaymentButton]);
  return isStubbed ? renderStubbedContent() : renderLiveContent();
};
export { StripePaymentElement as default };